import { useEffect, useState } from 'react';
import { getAiPostingRecommendations } from '../../../../../api';
import { useAuth } from '../../../../../contexts/AuthContext';
import { normalizePostingRecommendations } from './postingRecommendationModel';

/**
 * 나에게 맞는 공고를 불러온다.
 *
 * 지금 역할이 배우일 때만 묻는다. 서버가 오류를 주면(기능 꺼짐·허용 안 됨·서버 문제 모두)
 * 'hidden'으로 보고 섹션을 그리지 않는다 — 기능이 없는 계정과 화면이 같아야 한다.
 *
 * @param {{ limit?: number }} [options]
 * @returns {{ status: 'loading'|'ready'|'empty'|'hidden', items: Array }}
 */
export function useRecommendedPostings({ limit = 20 } = {}) {
  const { isLoggedIn, role } = useAuth();
  const canAsk = isLoggedIn && role === 'TALENT';
  const [state, setState] = useState({ status: canAsk ? 'loading' : 'hidden', items: [] });

  useEffect(() => {
    if (!canAsk) {
      setState({ status: 'hidden', items: [] });
      return undefined;
    }
    let alive = true;
    setState({ status: 'loading', items: [] });
    getAiPostingRecommendations({ limit })
      .then((data) => {
        if (!alive) return;
        const items = normalizePostingRecommendations(data);
        setState({ status: items.length > 0 ? 'ready' : 'empty', items });
      })
      .catch(() => {
        if (alive) setState({ status: 'hidden', items: [] });
      });
    return () => { alive = false; };
  }, [canAsk, limit]);

  return state;
}
